// src/config/auth0.config.js

/**
 * Auth0 Configuration
 * @see https://auth0.com/docs/quickstart/spa/react
 * 
 * IMPORTANT: All sensitive values should be stored in .env.local file
 * Never commit .env.local to version control
 */
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  scope: "openid profile email",
  redirectUri: typeof window !== 'undefined' ? window.location.origin : undefined,
  cacheLocation: "localstorage", // Use localstorage for token caching
  useRefreshTokens: true, // Enable refresh tokens
};


/**
 * Custom Claims Namespace
 * These are injected into the JWT by Auth0 Actions
 * The namespace should match your Auth0 API identifier
 */
export const AUTH0_CLAIMS = {
  ROLE: `${process.env.REACT_APP_AUTH0_AUDIENCE}/role`,
  USER_ID: `${process.env.REACT_APP_AUTH0_AUDIENCE}/userId`,
  EMAIL: `${process.env.REACT_APP_AUTH0_AUDIENCE}/email`,
  EMAIL_VERIFIED: `${process.env.REACT_APP_AUTH0_AUDIENCE}/email_verified`,
};

/**
 * User Roles
 */
export const USER_ROLES = {
  USER: "USER",
  FARMER: "FARMER",
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
};

/**
 * API Configuration
 */
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
};


